export default {
    isPaymentSetup: false,
    provider: process.env.VUE_APP_PAYMENT_PROVIDER,
    stripe: {
      public_key: process.env.VUE_APP_STRIPE_PUBLIC_KEY
    },
}